/**
 * MCP usage keys (card e1b83600). Rust notes which client called and which
 * surface each `tools/call` touched (src-tauri/src/mcp/usage_tally.rs — it sees
 * the native terminal/attachment tools the JS bus never does); this drains
 * that set every minute into the normal once-a-day counter. The keys are
 * re-checked against the allow-list by `recordFeature`, so Rust cannot widen
 * what is sent.
 *
 * The drain runs even with "Send usage data" off — it only empties Rust's set;
 * `recordFeature` then drops the keys, so nothing builds up and nothing leaves.
 */
import { invoke } from '@tauri-apps/api/core';
import { recordFeature } from './index';

const EVERY_MS = 60_000;

export async function drainMcpUsage() {
  try {
    const keys = await invoke('mcp_usage_drain');
    if (Array.isArray(keys)) keys.forEach((k) => recordFeature(k));
  } catch {
    // not in Tauri, or the command is missing: nothing to count
  }
}

/** Start the periodic drain; returns a stop function. */
export function startMcpUsageDrain() {
  const timer = setInterval(drainMcpUsage, EVERY_MS);
  return () => clearInterval(timer);
}
